import { sizes } from '../primitives/Media';
const SwiperBreakpointNoDefault = Object.freeze({
    EXTRA_SMALL: sizes.xs + 1,
    SMALL: sizes.s + 1,
    MEDIUM: sizes.m + 1,
    LARGE: sizes.l + 1,
    EXTRA_LARGE: sizes.xl + 1,
    EXTRA_EXTRA_LARGE: sizes.xxl + 1,
});
export const SwiperBreakpoint = Object.freeze({
    ...SwiperBreakpointNoDefault,
    DEFAULT: 'default',
});
export const slidesPerViewStage = Object.freeze({
    default: {
        [SwiperBreakpoint.EXTRA_SMALL]: 1,
        [SwiperBreakpoint.SMALL]: 1,
        [SwiperBreakpoint.MEDIUM]: 1,
        [SwiperBreakpoint.LARGE]: 1,
        [SwiperBreakpoint.EXTRA_LARGE]: 1.2,
        [SwiperBreakpoint.EXTRA_EXTRA_LARGE]: 1.5,
        [SwiperBreakpoint.DEFAULT]: 1,
    },
    '1x1': {
        [SwiperBreakpoint.EXTRA_SMALL]: 1.85,
        [SwiperBreakpoint.SMALL]: 2.5,
        [SwiperBreakpoint.MEDIUM]: 2.5,
        [SwiperBreakpoint.LARGE]: 2.5,
        [SwiperBreakpoint.EXTRA_LARGE]: 3.5,
        [SwiperBreakpoint.EXTRA_EXTRA_LARGE]: 4,
        [SwiperBreakpoint.DEFAULT]: 1,
    },
});
function getStageParams(stageRatio) {
    const ratio = stageRatio === '1x1' ? '1x1' : 'default';
    const breakpoints = {};
    Object.values(SwiperBreakpointNoDefault).forEach((breakpoint) => (breakpoints[breakpoint] = {
        slidesPerView: slidesPerViewStage[ratio][breakpoint],
        slidesPerGroup: 1,
    }));
    return {
        slidesPerView: slidesPerViewStage[ratio].default,
        slidesPerGroup: 1,
        breakpoints,
    };
}
function getResponsiveSwiperParams(stageRatio) {
    return [getStageParams(stageRatio), `stage:${stageRatio}`];
}
export default getResponsiveSwiperParams;
